module["exports"] = [
  "+351 91#######",
  "+351 93#######",
  "+351 96#######"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/pt_PT/cell_phone/formats.js
// module id = 3443
// module chunks = 1610